import React from 'react';
import { Components } from './styled';
import { parseDateToStringWithFormat } from '../../../../utils/dateFormat';
import { format } from '../../../../utils/dateFormat/types';

const Date = ({ params }: { params: any }) => {
  const { field, row }: { field: string; row: any } = params;
  const text =
    row?.[field] !== null && row?.[field] !== undefined
      ? parseDateToStringWithFormat(row[field], format.monthDayYear)
      : '-';

  return (
    <Components.Container>
      <Components.Text>{text}</Components.Text>
    </Components.Container>
  );
};

export default Date;
